import { apiCall } from 'api';
import api from 'services/api/microfwk';
import { SWAGGER_ENDPOINTS_WHITELIST } from './whiteList';
import { transformUrlPath } from './utils/transformPath';

export class HttpClient {
  constructor({
    whiteList = SWAGGER_ENDPOINTS_WHITELIST,
    hasClaroAdActive = false,
  }) {
    this.whiteList = whiteList;
    this.swaggerApiCall = apiCall;
    this.baseApiCall = api;
    this.hasClaroAdActive = hasClaroAdActive;
  }

  async get(url = '', params = {}) {
    try {
      if (this.whiteList.includes(url) && this.hasClaroAdActive) {
        return await this.swaggerApiCall.get(transformUrlPath(url), { params });
      } else {
        return await this.baseApiCall.get(url, { params });
      }
    } catch (error) {
      throw error
    }
  }

  async post(url = '', formData = {}, params = {}) {
    try {
      if (this.whiteList.includes(url) && this.hasClaroAdActive) {
        return await this.swaggerApiCall.post(url, formData, { params });
      } else {
        return await this.baseApiCall.post(url,formData, { params });
      }
    } catch (error) {
      throw error;
    }
  }
}
